/* ==========================================================================
   Desktop mega menu: hover intent + keyboard accessibility
   ========================================================================== */
(function () {
  'use strict';

  var nav = document.querySelector('[data-mega-menu-nav]');
  if (!nav) return;

  var items = nav.querySelectorAll('[data-mega-menu-item]');
  var closeTimer;

  function closeAll() {
    items.forEach(function (item) {
      item.classList.remove('is-open');
      var link = item.querySelector('.header__nav-link');
      if (link) link.setAttribute('aria-expanded', 'false');
    });
  }

  function openItem(item) {
    closeAll();
    item.classList.add('is-open');
    var link = item.querySelector('.header__nav-link');
    if (link) link.setAttribute('aria-expanded', 'true');
  }

  items.forEach(function (item) {
    if (!item.hasAttribute('data-mega-menu-target')) return;

    item.addEventListener('mouseenter', function () {
      clearTimeout(closeTimer);
      openItem(item);
    });

    item.addEventListener('mouseleave', function () {
      closeTimer = setTimeout(closeAll, 150);
    });

    var link = item.querySelector('.header__nav-link');
    if (link) {
      link.addEventListener('focus', function () {
        openItem(item);
      });
    }
  });

  nav.addEventListener('focusout', function (event) {
    if (!nav.contains(event.relatedTarget)) {
      closeAll();
    }
  });

  document.addEventListener('theme:escape', closeAll);

  document.addEventListener('click', function (event) {
    if (!nav.contains(event.target)) closeAll();
  });
})();
